import { useAsiAccessDecision } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
import { useIsEnterpriseUser } from '#pplx/frontend/auth/useIsEnterpriseUser.js';
export function useAsiAllowedByOrganizationState() {
    const isEnterpriseUser = useIsEnterpriseUser();
    const { data: accessDecision, isLoading } = useAsiAccessDecision({
        enabled: isEnterpriseUser,
    });
    if (!isEnterpriseUser) {
        return { enabled: true, loading: false };
    }
    // The backend access decision resolves permissions-platform product
    // entitlements plus the org-wide Computer switch. `admin_disabled` is the
    // entitlement-aware successor of the legacy per-member `orgUser.asi_allowed`
    // flag, which never sees Computer grants made through the RBAC roles page
    // and would mark entitled members as org-disabled (and vice versa).
    //
    // Deliberately keyed on the denial REASON, not `can_use_computer`: this
    // hook answers "did org policy disable Computer" (rendered as "Disabled by
    // your organization"), not "can the user use Computer" — that is
    // `useCanUseComputer`, enforced at submit. Any denial reason other than
    // `admin_disabled` (none exist today) is not org policy and must resolve
    // enabled=true here so it isn't misattributed to the org admin.
    return {
        enabled: accessDecision?.denial_reason !== 'admin_disabled',
        loading: isLoading,
    };
}
export function useAsiAllowedByOrganization() {
    const { enabled } = useAsiAllowedByOrganizationState();
    return enabled;
}
//# sourceMappingURL=useAsiAllowedByOrganization.js.map